import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

import SettingTextField from "../../../components/SettingTextField";
import UploadLogo from "../../../components/UploadLogo";

import styles from "./SocialMedia.module.css";
import { getImgDetail } from "./PortalState/dataTransformerUtilities";
import { SocialMediaFields, SectionNames } from "./PortalState/SectionDataMetaData";

const SocialMedia = (props) => {
  const { data, uploadLogoFile, imageLoading, index, handleChange, onDeleteEntry, errors, isLast } = props;

  const onDelete = () => {
    onDeleteEntry(SectionNames.socialMediaTab, index);
  };

  const handleInputChange = (field, value) => {
    handleChange(SectionNames.socialMediaTab, field, value, index);
  };

  const errorSx = { color: "#d32f2f", fontSize: "12px", fontFamily: "GilroyMedium" };

  return (
    <Grid
      item
      container
      xs={12}
      justifyContent="space-between"
      sx={isLast ? {} : { borderBottom: "2px solid #AAA" }}
      pb={2}
      mb={isLast ? 0 : 2}
    >
      <Grid item xs={12} md={5.8} mt={2}>
        <Box mb={1}>
          <Typography className={styles.textInputLabel}>Name</Typography>
        </Box>
        <Box>
          <SettingTextField
            editable={true}
            value={data[SocialMediaFields.name]}
            setValue={(val) => handleInputChange(SocialMediaFields.name, val)}
            placeholder={""}
            required={true}
            variant={"filled"}
            border={"1px solid #AAA"}
            error={errors.get(`${index}_${SocialMediaFields.name}`)}
            errorStyles={errorSx}
          />
        </Box>
      </Grid>
      <Grid item xs={12} md={5.8} mt={2}>
        <Box mb={1}>
          <Typography className={styles.textInputLabel}>Url</Typography>
        </Box>
        <Box>
          <SettingTextField
            editable={true}
            value={data[SocialMediaFields.url] ?? null}
            setValue={(val) => handleInputChange(SocialMediaFields.url, val)}
            placeholder={""}
            required={true}
            variant={"filled"}
            border={"1px solid #AAA"}
            error={errors.get(`${index}_${SocialMediaFields.url}`)}
            errorStyles={errorSx}
          />
        </Box>
      </Grid>
      <Grid item xs={12} md={5.8} mt={2}>
        <Box mb={1}>
          <Typography className={styles.textInputLabel}>Action</Typography>
        </Box>
        <Box>
          <SettingTextField
            editable={true}
            value={data[SocialMediaFields.action] ?? null}
            setValue={(val) => handleInputChange(SocialMediaFields.action, val)}
            placeholder={""}
            required={true}
            variant={"filled"}
            border={"1px solid #AAA"}
            error={errors.get(`${index}_${SocialMediaFields.action}`)}
            errorStyles={errorSx}
          />
        </Box>
      </Grid>
      <Grid item xs={12} md={5.8} mt={2}>
        <Box mb={1}>
          <Typography className={styles.textInputLabel}>Icon width</Typography>
        </Box>
        <Box>
          <SettingTextField
            editable={true}
            value={data[SocialMediaFields.iconWidth] ?? null}
            setValue={(val) =>
              handleInputChange("iconWidth", val.replace(/[^0-9.]/g, ""))
            }
            placeholder={""}
            required={true}
            variant={"filled"}
            border={"1px solid #AAA"}
            error={errors.get(`${index}_${SocialMediaFields.iconWidth}`)}
            errorStyles={errorSx}
          />
        </Box>
      </Grid>
      <Grid item xs={12} md={5.8} mt={2}>
        <Box mb={1}>
          <Typography className={styles.textInputLabel}>Icon height</Typography>
        </Box>
        <Box>
          <SettingTextField
            editable={true}
            value={data[SocialMediaFields.iconHeight] ?? null}
            setValue={(val) =>
              handleInputChange("iconHeight", val.replace(/[^0-9.]/g, ""))
            }
            placeholder={""}
            required={true}
            variant={"filled"}
            border={"1px solid #AAA"}
            error={errors.get(`${index}_${SocialMediaFields.iconHeight}`)}
            errorStyles={errorSx}
          />
        </Box>
      </Grid>
      <Grid item xs={12} md={5.8} mt={2}>
        <Box mr={2} mb={1}>
          <UploadLogo
            type={props.index}
            sectionName={SectionNames.socialMediaTab}
            uploadFile={(data, file) => uploadLogoFile(data, file, index, SectionNames.socialMediaTab)}
            imageLoading={imageLoading}
            logoImg={
              typeof data[SocialMediaFields.icon] == "string" && data[SocialMediaFields.icon]
                ? getImgDetail(data[SocialMediaFields.icon], "SocialMedia")
                : data[SocialMediaFields.icon]
                  ? data[SocialMediaFields.icon]
                  : ""
            }
            imageType={props.imageType}
            placeholder={"SOCIAL LOGO"}
            showViewUploadIcon={true}
            onRemove={() => handleInputChange("icon", "")}
          />
          {errors.has(`${index}_icon`) &&
            <Typography sx={{ color: "#d32f2f", fontSize: "12px", fontFamily: "GilroyMedium" }}>
              {errors.get(`${index}_${SocialMediaFields.icon}`)}
            </Typography>
          }
        </Box>
      </Grid>
      <Grid container item xs={12} mt={2} justifyContent={"flex-end"}>
        <Button
          type="button"
          disabled={props.imageLoading}
          className={styles.deleteBtn}
          sx={{
            opacity: props.imageLoading ? 0.2 : 1,
          }}
          onClick={props.imageLoading ? null : onDelete}
        >
          Delete
        </Button>
      </Grid>
    </Grid>
  );
};

export default SocialMedia;
